import * as React from 'react'

import Page from '../components/Page'
import Container from '../components/Container'

import { CardListContainer } from '../containers/CardListContainer'

export default () => (
  <Page>
    <Container>
      <CardListContainer />
    </Container>
  </Page>
)



// WEBPACK FOOTER //
// ./src/pages/index.tsx